import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { useAuth } from "../../../../context/AuthContext";

const initialForm = {
  name: "",
  is_active: true,
};

export default function StoreBrandFormModal({
  open,
  onClose,
  brand,
  reload,
  showBanner,
}) {
  const { authFetch } = useAuth();

  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [banner, setBanner] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    if (!open) {
      setForm(initialForm);
      setBanner({ type: "", message: "" });
      return;
    }

    if (brand) {
      setForm({
        name: brand.name || "",
        is_active:
          typeof brand.is_active === "boolean" ? brand.is_active : true,
      });
    } else {
      setForm(initialForm);
    }

    setBanner({ type: "", message: "" });
  }, [open, brand]);

  const handleChange = (field) => (event) => {
    const value =
      field === "is_active" ? event.target.checked : event.target.value;

    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (banner.message) {
      setBanner({ type: "", message: "" });
    }
  };

  const handleSubmit = async () => {
    const cleanName = form.name.trim();

    if (!cleanName) {
      setBanner({
        type: "error",
        message: "Ingresa el nombre de la marca",
      });
      return;
    }

    setLoading(true);

    try {
      const url = brand
        ? `/api/store/brands/${brand.uuid}/update/`
        : "/api/store/brands/create/";

      const method = brand ? "PATCH" : "POST";

      const payload = brand
        ? {
            name: cleanName,
            is_active: form.is_active,
          }
        : {
            name: cleanName,
          };

      const response = await authFetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      let data = {};

      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (!response.ok) {
        setBanner({
          type: "error",
          message: data?.error || "No se pudo guardar la marca",
        });
        return;
      }

      showBanner(
        "success",
        data?.message ||
          (brand
            ? "Marca actualizada correctamente"
            : "Marca creada correctamente")
      );

      if (reload) {
        await reload();
      }

      onClose();
    } catch {
      setBanner({
        type: "error",
        message: "Ocurrió un error al guardar la marca",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{brand ? "Editar marca" : "Nueva marca"}</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ pt: 0.6 }}>
          {!!banner.message && (
            <Alert severity={banner.type || "error"}>{banner.message}</Alert>
          )}

          <TextField
            label="Nombre"
            value={form.name}
            onChange={handleChange("name")}
            fullWidth
            autoFocus
          />

          {brand && (
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_active}
                  onChange={handleChange("is_active")}
                />
              }
              label="Marca activa"
            />
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>

        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {brand ? "Guardar cambios" : "Crear marca"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}